
    <select #langSelect (change)="onLangChange(langSelect.value)" class="language-select-box">
      <option
        *ngFor="let lang of langs"
        [value]="lang.id"
        [attr.selected]="lang.id === translate.currentLang ? '' : null"
      >{{lang.name}}</option>
    </select>
  